<template>
	<div class="wh100" style="height: 100%;">
<!--			<el-row :gutter="20" v-if="!isDialog">
				<el-col :span="4">
					<span>最近48小时报警信息</span>
				</el-col>
			</el-row>
			<el-row v-if="isDialog">
				<el-col :span="4">
					<el-button type="primary" @click="exportData">导出</el-button>
				</el-col>
			</el-row>-->
    <MyPannel style="height: 100%" :title="isDialog?'':'最近48小时报警信息'">
      <my-table
			  ref="mytable"
			  id="mytable"
			  :url="table.url"
			  :method="table.method"
			  :params="params"
			  index-column
			  custom-sort
			  stripe
			  fit
			  border
        :height="'40vw'"
			>
				<template slot="columns" v-if="isOffline">
					<el-table-column
					  prop="stationname"
					  label="站点名称"
					  align="center"
					  min-width="150"
					  show-overflow-tooltip
					>
					</el-table-column>
					<el-table-column
					  prop="stationcode"
					  label="站点编号"
					  align="center"
					  min-width="150"
					  show-overflow-tooltip
					>
					</el-table-column>
					<el-table-column
					  prop="startTime"
					  label="开始时间"
					  align="center"
					  min-width="150"
					  show-overflow-tooltip
					>
					</el-table-column>
					<el-table-column
					  prop="endTime"
					  label="结束时间"
					  align="center"
					  min-width="150"
					  show-overflow-tooltip
					>
					</el-table-column>
					<el-table-column
					  prop="hourlength"
					  label="离线时长"
					  align="center"
					  min-width="150"
					  show-overflow-tooltip
					>
					</el-table-column>
				</template>
				<template slot="columns" v-else>
					<el-table-column
					  prop="stationname"
					  label="站点名称"
					  align="center"
					  min-width="150"
					  show-overflow-tooltip
					>
					</el-table-column>
					<el-table-column
					  prop="alarmtime"
					  label="报警时间"
					  align="center"
					  min-width="100"
					  sortable
					>
					</el-table-column>
					<el-table-column
					  prop="itemname"
					  label="报警参数"
					  align="center"
					  min-width="100"
					  sortable
					>
					</el-table-column>
					<el-table-column
					  prop="alarmtypename"
					  label="报警类型"
					  align="center"
					  min-width="100"
					  sortable
					>
					</el-table-column>
					<el-table-column
					  prop="alarminfo"
					  label="报警信息"
					  align="center"
					  min-width="150"
					  show-overflow-tooltip
					>
					</el-table-column>
				</template>
			</my-table>
    </MyPannel>
	</div>
</template>

<script>
import MyPannel from "@/components/Pannel/Pannel";
import MyTable from "@/components/PageTable";
export default {
  components: {
    MyPannel,
    MyTable,
  },
  props: ["buildingInfo","startTime","endTime","isDialog","alarmType","isOffline"],
  data() {
    return {
		params:{
			timeStart:this.startTime?this.startTime:this.$util.formatDate24(new Date(new Date().getTime()-24*60*60*1000),"yyyy-MM-dd 00:00:00"),
			timeEnd:this.endTime?this.endTime:this.$util.formatDate24(new Date(),"yyyy-MM-dd 23:59:59"),
			buildingSiteId:this.buildingInfo.id,
			alarmTypeCode:this.alarmType,
		},
		table:{
			url:"/baseStation/getStationAlarmBySiteId",
			method:"POST",
		},
	};
  },
  mounted() {
	
  },
  methods:{
	query() {
	  this.$refs.mytable.reload();
	},
	exportData(){
		let _this = this;
		let url = _myconfig.apiBaseUrl + "/baseStation/exportAlarmReportData";
		if(this.isOffline){
			_this.params.type="off";
		}
		_this.$api.downloadFile("POST", "/baseStation/exportAlarmReportData", _this.params);
	},
  },
}
</script>

<style>
</style>